import { Reveal, Chapter } from "./Reveal";
import { Plus } from "lucide-react";

export default function Qualification() {
  return (
    <section data-testid="qualification-section" className="bg-[#002B54] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <Chapter number="06" label="Kam tas paredzēts" dark />
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <Reveal>
            <h2 className="font-display font-black tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-white" data-testid="qualification-heading">
              Kam paredzēts{" "}
              <span className="text-white/30">bezmaksas audits?</span>
            </h2>
            <p className="mt-8 text-white/55 text-base leading-relaxed">
              Audits ir paredzēts uzņēmumiem, kuri digitālo reklāmu izmanto pārdošanas vai klientu
              piesaistes veicināšanai, nevis tikai zīmola atpazīstamības celšanai.
            </p>
            <p className="mt-4 text-white/55 text-base leading-relaxed">
              Audits būs īpaši noderīgs, ja regulāri izmantojat banerus vai video Meta, Google,
              YouTube, TikTok vai citos digitālajos kanālos un vēlaties saprast, vai esošie kreatīvi
              palīdz pilnvērtīgi izmantot Jūsu reklāmas budžetu.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-white/40 mb-5">Audita kvalifikācijas kritēriji</p>
            <div className="rounded-sm border border-white/15 bg-[#003E75] p-8 md:p-10" data-testid="qualification-card-1">
              <p className="text-white/45 text-sm">Gada apgrozījums no</p>
              <p className="mt-2 font-display font-black tracking-tighter text-4xl md:text-6xl text-[#ED1C27]">€500 000</p>
            </div>
            <div className="flex justify-center py-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#ED1C27]">
                <Plus className="h-4 w-4 text-white" />
              </span>
            </div>
            <div className="rounded-sm border border-white/15 bg-[#003E75] p-8 md:p-10" data-testid="qualification-card-2">
              <p className="text-white/45 text-sm">Digitālās reklāmas budžets no</p>
              <p className="mt-2 font-display font-black tracking-tighter text-4xl md:text-6xl text-[#ED1C27]">€2 000 <span className="text-white/40 text-2xl">mēnesī</span></p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
